export default {
  state: () => ({
    buttons: {
      upload: 'upload',
      create: 'create',
      remove: 'remove',
      save: 'save',
      resize: 'resize'
    },
    viewBoxModalOpened: false,
    viewBox: { x: 0, y: 0, w: 720, h: 540 }, // 4:3
    polygonModalOpened: false
  }),

  getters: {
    getRandomColor() {
      return () => {
        let color = '#'
        let letters = '0123456789ABCDEF'.split('')

        for (let i = 0; i < 6; i++) {
          color += letters[Math.floor(Math.random() * 16)]
        }

        return color
      }
    },

    computedViewBox(state) {
      let { x, y, w, h } = state.viewBox
      return `${x} ${y} ${w} ${h}`
    }
  },

  mutations: {
    openViewBoxModal(state) {
      state.viewBoxModalOpened = true
    },

    closeViewBoxModal(state) {
      state.viewBoxModalOpened = false
    },

    openPolygonModal(state) {
      state.polygonModalOpened = true
    },

    closePolygonModal(state) {
      state.polygonModalOpened = false
    },

    setViewBox(state, viewBox) {
      state.viewBox = viewBox
    }
  },

  actions: {},

  namespaced: true
}
